import axios from "axios";
import authHeader from "@/services/auth-header";

const main = "BytePro";
const sub = "OrgCompPlan";

class OrgCompPlanService {
  get(organizationId) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/${main}/${sub}/${organizationId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new OrgCompPlanService();
